import { useCallback, useState } from "react";

/**
 * Ref callback for the spacer after the rows, which is `--dg-scroll-end-inset`
 * tall: extra scroll room for a bar floating over the grid's bottom edge (a
 * command island). Returns its height in px so keyboard scrolling keeps the
 * focused row above the bar too.
 */
export const useScrollEndInset = () => {
    const [inset, setInset] = useState(0);
    const spacerRef = useCallback((spacer: HTMLDivElement | null) => {
        if (!spacer) {
            return undefined;
        }
        const resizeObserver = new ResizeObserver((entries) => {
            const entry = entries[entries.length - 1];
            if (entry) {
                setInset(Math.round(entry.contentRect.height));
            }
        });
        resizeObserver.observe(spacer);
        return () => {
            resizeObserver.disconnect();
            setInset(0);
        };
    }, []);
    return { spacerRef, inset };
};
